var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"},{name:"scroll-to",rawName:"v-scroll-to",value:('#__layout'),expression:"'#__layout'"}],staticClass:"to_top_btn icon-arrow_up"},[_vm._v("\n\t"+_vm._s(_vm.$t('up'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }